import { render, staticRenderFns } from "./FilterUC.vue?vue&type=template&id=5148dcf2&"
import script from "./FilterUC.vue?vue&type=script&lang=js&"
export * from "./FilterUC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports